import {
  ON_CLICK,
  ON_CONTENT,
  ON_DISPLAY,
  ON_VIEWMORE,
  ON_NAVIGATION,
  ON_MOVETAB,
  ON_ZZIM,
  OFF_ZZIM,
  ON_INSTANTPLAY
} from '@/common/event.const'
import { parseUrl } from 'query-string'
import utils from '@/common/util/utils'
import { get, set, map, split, fromPairs } from 'lodash'

export const getEventListByType = (eventList = []) => {
  let onClickEvent = null
  let onDisplayEvent = null
  let onContentEvent = null
  let onViewMoreEvent = null
  let onNavigationEvent = null
  let onMoveTabEvent = null
  let onZzimEvent = null
  let offZzimEvent = null
  let onInstantPlay = null
  eventList.forEach((event) => {
    switch (event.type) {
      case ON_CLICK:
        onClickEvent = event
        break
      case ON_DISPLAY:
        onDisplayEvent = event
        break
      case ON_CONTENT:
        onContentEvent = event
        break
      case ON_VIEWMORE:
        onViewMoreEvent = event
        break
      case ON_NAVIGATION:
        onNavigationEvent = event
        break
      case ON_MOVETAB:
        onMoveTabEvent = event
        break
      case ON_ZZIM:
        onZzimEvent = event
        break
      case OFF_ZZIM:
        offZzimEvent = event
        break
      case ON_INSTANTPLAY:
        onInstantPlay = event
        break
    }
  })
  return {
    onClickEvent,
    onDisplayEvent,
    onContentEvent,
    onViewMoreEvent,
    onNavigationEvent,
    onMoveTabEvent,
    onZzimEvent,
    offZzimEvent,
    onInstantPlay
  }
}

export const getUiTypeFromUrl = (url) => {
  const { query } = parseUrl(url)
  return get(query, 'uitype', null)
}

export const eventBodyListParser = (eventObject) => {
  const bodyList = get(eventObject, 'bodylist', [])
  const keyValuePair = map(bodyList, bodyStr => split(bodyStr, ':'))
  const keyValueObj = fromPairs(keyValuePair)
  return set(keyValueObj, 'timestamp', utils.getTimeStamp())
}
